$.lui("comp",".comp_visual_photos",function (selector) {
    selector.on("mouseenter",".col--image",function (e) {
        $(this).find(".type--hover").show();
    });
    if(win.width() > 960) {
        setTimeout(()=>{
            selector.find(".part_ui_scroll").fadeIn();
        },750)
    }
});